import React, { useState, useEffect } from 'react';
import axiosInstance from '../axiosInstance';

function Profile() {
    const [data, setData] = useState({ name: '', phone: '' });
    const [isEditing, setIsEditing] = useState(false);
    const [id, setId] = useState(null);
    const [originalData, setOriginalData] = useState({});
    const [profileImage, setProfileImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const Email = localStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosInstance.get(`/user/email/${Email}`);
                const user = response.data;

                setData({ name: user.name || '', phone: user.phone || '' });
                setId(user.id);
                setOriginalData(user);

                // Set preview, fallback if no image
                setPreview(user.profile_picture 
                    ? `https://apiemiride.socialpartners.in/api/user/profilepicture/${user.profile_picture}` 
                    : `/dist/pic/profilepic.jpeg`
                );
            } catch (error) {
                console.error('Error fetching profile:', error);
            }
        };
        fetchData();
    }, [Email]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData(prev => ({ ...prev, [name]: value }));
    };

    const handleEdit = () => setIsEditing(true);

    const handleCancel = () => {
        setData({ name: originalData.name, phone: originalData.phone });
        setProfileImage(null);
        setPreview(originalData.profile_picture 
            ? `https://apiemiride.socialpartners.in/api/user/profilepicture/${originalData.profile_picture}` 
            : `/dist/pic/profilepic.jpeg`
        );
        setIsEditing(false);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProfileImage(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleSave = async () => {
        try {
            const formData = new FormData();
            formData.append('name', data.name);
            formData.append('phone', data.phone);
            if (profileImage) formData.append('file', profileImage);

            const response = await axiosInstance.put(
                `/user/update_profile/${id}`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            const updated = response.data;

            setData({ name: updated.name, phone: updated.phone });
            setOriginalData(updated);

            localStorage.setItem('name', updated.name);
            localStorage.setItem('phone', updated.phone);
            if (updated.profile_picture) {
                localStorage.setItem('profile_picture', updated.profile_picture);
                setPreview(`https://apiemiride.socialpartners.in/api/user/profilepicture/${updated.profile_picture}`);
            } else {
                setPreview(`/dist/pic/profilepic.jpeg`);
            }

            setIsEditing(false);
        } catch (error) {
            console.error('Error saving profile:', error);
        }
    };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">My Profile</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Profile</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="card card-info">
                                <div className="card-header d-flex align-items-center justify-content-between">
                                    <h3 className="card-title">
                                        <i className="fas fa-user-circle mr-2"></i> Profile Details
                                    </h3>
                                    {preview && (
                                        <img
                                            src={preview}
                                            alt="Profile Preview"
                                            className="img-thumbnail"
                                            style={{ width: '60px', height: '60px', borderRadius: '50%' }}
                                            onError={(e) => e.target.src = `/dist/pic/profilepic.jpeg`}
                                        />
                                    )}
                                </div>
                                <div className="card-body">
                                    <form>
                                        <input type="hidden" name="id" value={id || ''} />

                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">Name</label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="form-control"
                                                    value={data.name}
                                                    onChange={handleInputChange}
                                                    disabled={!isEditing}
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">Phone</label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    name="phone"
                                                    className="form-control"
                                                    value={data.phone}
                                                    onChange={handleInputChange}
                                                    disabled={!isEditing}
                                                />
                                            </div>
                                        </div>

                                        {isEditing && (
                                            <div className="form-group row">
                                                <label className="col-sm-3 col-form-label">Profile Picture</label>
                                                <div className="col-sm-9">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        className="form-control"
                                                        onChange={handleImageChange}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        <div className="form-group row mt-4">
                                            <div className="col-sm-12 text-right">
                                                {isEditing ? (
                                                    <>
                                                        <button type="button" className="btn btn-success mr-2" onClick={handleSave}>
                                                            <i className="fas fa-save mr-1"></i> Save
                                                        </button>
                                                        <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                                                            <i className="fas fa-times mr-1"></i> Cancel
                                                        </button>
                                                    </>
                                                ) : (
                                                    <button type="button" className="btn btn-primary" onClick={handleEdit}>
                                                        <i className="fas fa-edit mr-1"></i> Edit
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="card-footer text-muted text-center">
                                    Last updated recently
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Profile;
